import React from 'react'

function ToolsDropdown(props) {
    const tools = [];
    class Tool{
        constructor(name,className,isAnAdvancedTool){
            this.name = name;
            this.className = className;
            this.isAnAdvancedTool = isAnAdvancedTool;
        }
    }
    tools.push(new Tool("Hammer","hammerCursor",false));
    tools.push(new Tool("Screwdriver","screwdriverCursor",false));
    tools.push(new Tool("Saw","sawCursor",false));
    tools.push(new Tool("Synthesiser","synthesiserCursor",true));
    tools.push(new Tool("Cat Biscuits","catBiscuitsCursor",true));
    tools.push(new Tool("Combine Harvester","combineHarvesterCursor",true));

    function deactivateAllTools(){
        for (let i = 0; i < tools.length; i++) {
            document.body.classList.remove(tools[i].className);
        }
    }
    function activateTool(tool){
        deactivateAllTools();
        document.body.classList.add(tool.className);
        props.toggleDropdown();
    }
    function handleNoToolClick(){
        deactivateAllTools();
        props.toggleDropdown();
    }

    const standardToolsAsElements = [];
    const advancedToolsAsElements = [];
    for (let i = 0; i < tools.length; i++) {
        if(tools[i].isAnAdvancedTool){
            advancedToolsAsElements.push(<p key={tools[i].name} onClick={() => activateTool(tools[i])}>{tools[i].name}</p>);        
        }else{
            standardToolsAsElements.push(<p key={tools[i].name} onClick={() => activateTool(tools[i])}>{tools[i].name}</p>);        
        }
    }

    return (
        <div id="toolsDropdownMenu" className="hidden">
            {standardToolsAsElements}
            <span id="advancedToolOptions" className="hidden">
                {advancedToolsAsElements}
            </span>
            <p onClick={handleNoToolClick}>No tool</p>
        </div>
    )
}

export default ToolsDropdown